import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import Stack from "@mui/material/Stack";
import { ListSubheader, Tooltip } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import ListItemText from "@mui/material/ListItemText";
import Checkbox from "@mui/material/Checkbox";

const SelectField = ({
  label,
  required,
  mandatory,
  onChange,
  value,
  options,
  subHeader,
  tooltip,
  ...props
}) => {
  return (
    <Stack direction="row" className="modal-stack">
      {label && (
        <InputLabel required={mandatory} className="flex-2 word-break">
          {label}
          {tooltip && (
            <Tooltip title={tooltip} arrow followCursor>
              <ErrorOutlineIcon fontSize="small" />
            </Tooltip>
          )}
        </InputLabel>
      )}
      {/* <Select
        multiple
        value={Array.isArray(value) ? value : []}
        onChange={onChange}
        required={required}
        renderValue={(selected) => selected.join(", ")}
        sx={{ maxWidth: 450 }}
        {...props}>
        {options?.map((item) => (
          <MenuItem key={item.id} value={typeof item === "object" ? item.id : item}>
            <Checkbox checked={value.includes(item.id)} />
            <ListItemText primary={item.name} />
          </MenuItem>
        ))}
        {subHeader && (
          <>
            <ListSubheader className="background-grey">Other</ListSubheader>
            {subHeader.map((item, key) => (
              <MenuItem key={key} value={item}>
                {item}
              </MenuItem>
            ))}
          </>
        )}
      </Select> */}
      <Select
        multiple
        value={Array.isArray(value) ? value : []}
        onChange={onChange}
        required={required}
        renderValue={(selected) => {
          const names = selected
            .map((id) => options.find((item) => item.id === id)?.name || id)
            .join(", ");

          return (
            <Tooltip title={names} arrow>
              <span
                style={{
                  display: "block",
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis"
                }}>
                {names}
              </span>
            </Tooltip>
          );
        }}
        sx={{
          width: 420, // Fixed width
          maxWidth: 450, // Optional max width
          "& .MuiSelect-select": {
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
          }
        }}
        {...props}>
        {options?.map((item) => (
          <MenuItem key={item.id} value={item.id}>
            <Checkbox checked={value.includes(item.id)} />
            <ListItemText primary={item.name} />
          </MenuItem>
        ))}
        {subHeader && (
          <>
            <ListSubheader className="background-grey">Other</ListSubheader>
            {subHeader.map((item, key) => (
              <MenuItem key={key} value={item}>
                {item}
              </MenuItem>
            ))}
          </>
        )}
      </Select>
    </Stack>
  );
};

export default SelectField;
